import React from 'react';
import { Breadcrumbs, Link, Typography, Box } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import HomeIcon from '@mui/icons-material/Home';
import { useLocation, useParams } from 'react-router-dom';
import { useDms } from '../contexts/DmsContext';

const VAULT_LABELS = {
  procedures: 'Procedures', legal: 'Legal', technical: 'Technical',
  financial: 'Financial', marketing: 'Marketing', contracts: 'Contracts',
  customer: 'Customer', hr: 'HR', compliance: 'Compliance',
};

const PATH_LABELS = {
  '/search': 'AI Search',
  '/workflows': 'Workflows',
  '/templates': 'Templates',
  '/analytics': 'Analytics',
  '/audit': 'Audit Log',
  '/compliance': 'Compliance',
  '/editor': 'Document Editor',
  '/manual': 'Manual Editor',
  '/tech-manual': 'Technical Docs',
  '/customer': 'My Documents',
};

const DmsBreadcrumbs = ({ documentTitle, onNavigate }) => {
  const location = useLocation();
  const { vaultId } = useParams();
  const { selectedVault } = useDms();

  const crumbs = [
    { label: 'Dashboard', icon: <HomeIcon sx={{ fontSize: 16, mr: 0.5 }} />, path: '/' },
  ];

  const vault = vaultId || (location.pathname.startsWith('/vault/') ? selectedVault : null);
  if (vault) {
    crumbs.push({ label: VAULT_LABELS[vault] || vault, path: `/vault/${vault}` });
  }

  if (documentTitle) {
    crumbs.push({ label: documentTitle, path: null });
  } else if (PATH_LABELS[location.pathname]) {
    crumbs.push({ label: PATH_LABELS[location.pathname], path: null });
  }

  if (crumbs.length <= 1) return null;

  return (
    <Box sx={{ px: { xs: 2, sm: 3 }, py: 1, borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
        {crumbs.map((crumb, idx) => {
          const isLast = idx === crumbs.length - 1;
          if (isLast) {
            return (
              <Typography key={idx} color="text.primary" sx={{ fontSize: '0.8rem', fontWeight: 600, display: 'flex', alignItems: 'center' }}>
                {crumb.icon}{crumb.label}
              </Typography>
            );
          }
          return (
            <Link
              key={idx}
              component="button"
              onClick={() => crumb.path && onNavigate?.(crumb.path)}
              sx={{
                fontSize: '0.8rem', display: 'flex', alignItems: 'center',
                color: 'text.secondary', textDecoration: 'none', background: 'none',
                border: 'none', cursor: 'pointer',
                '&:hover': { color: 'primary.main', textDecoration: 'underline' },
              }}
            >
              {crumb.icon}{crumb.label}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default DmsBreadcrumbs;